<div class="container-fluid">

  <div class="row margin-top-15" tabindex="0">
    <div class="container d-flex align-items-center justify-content-center">
      <img alt="pictogramme durée" class="center-block picto-35px" src="/icfstatiquesangularappli/dist/images/usager/pic_temps.png">
    </div>
    <div class="col-sm-10">
      Durée estimée : 5 minutes
    </div>
  </div>

  <div class="row margin-top-15" tabindex="0">
    <div class="container d-flex align-items-center justify-content-center">
      <img alt="pictogramme durée" class="center-block picto-35px" src="/icfstatiquesangularappli/dist/images/usager/pic-calcul.png">
    </div>
    <div class="col-sm-10">
      <span>
        Le montant de l’aide au logement indiqué par ce simulateur est une estimation. Seule la demande d’aide au logement vous permettra de connaître le montant exact.
      </span>
    </div>
  </div>

  <div class="row margin-top-15" tabindex="0">
    <div class="container d-flex align-items-center justify-content-center">
      <img alt="pictogramme durée" class="center-block picto-30px" src="/icfstatiquesangularappli/dist/images/usager/pic-info.png">
    </div>
    <div class="col-sm-10">
      <label class="label-cnaf" style="font-weight: normal">Cette simulation est valable uniquement pour les personnes :</label>
      <ul>
        <li>de nationalité française ou étrangère en possession d’un titre de séjour ;</li>
        <li>locataires et sans lien de parenté avec le propriétaire (parents, grands-parents, enfants et petits-enfants) ;</li>
        <li>dont les parents ne sont pas assujettis à l’impôt sur la fortune immobilière ;</li>
        <li>titulaires d’un bail (sauf pour les personnes mineures pour qui le bail peut être au nom des parents).</li>
        <li>accédant à la propriété en Outre-mer.</li>


      </ul>
      <label class="label-cnaf" style="font-weight: normal">Cette simulation ne tient pas compte :</label>
      <ul>
        <li>de certains abattements dont vous pouvez bénéficier (ex: abattement appliqué à vos revenus
          l’année suivant votre départ en retraite) ;</li>
        <li>de certaines charges (pensions alimentaires versées, frais réels) ;</li>
        <li>de la Réduction de Loyer de Solidarité (RLS).</li>
      </ul>
      <p>Si vous êtes concerné, le montant de votre aide au logement pourrait être différent du résultat proposé par cette simulation.</p>
    </div>
  </div>

  <div class="row margin-top-15" tabindex="0">
    <div class="container d-flex align-items-center justify-content-center">
      <img alt="pictogramme durée" class="center-block " src="/icfstatiquesangularappli/dist/images/pic-attention.png">
    </div>
    <div class="col-sm-10">
      <p>Attention : vous devez indiquer dans ce simulateur vos ressources nettes imposables, c’est-à-dire vos ressources diminuées des exonérations fiscales auxquelles vous
        avez droit (par exemple si vous êtes assistant maternel, assistant familial, journaliste, apprenti ou stagiaire).</p>
    </div>
  </div>

  <div class="row margin-top-15" tabindex="0">
    <div class="container d-flex align-items-center justify-content-center">
      <img alt="pictogramme durée" class="center-block picto-30px" src="/icfstatiquesangularappli/dist/images/usager/PicTP-aide.png">
    </div>
    <div class="col-sm-10">
      <p>Des bulles d’aide s’affichent pour vous expliquer les informations à saisir. Cliquez sur le point d’interrogation pour y accéder.</p>
      <p>Les informations saisies ne sont pas conservées.</p>
    </div>
  </div>

  <!-- Barre de bouton -->
  <div class="row row-btn-cnaf" tabindex="0">
      <div class="col-sm-12 form-group">
          <app-bouton-quitter [pageName]="pageName"></app-bouton-quitter>
          <span class="float-end">
              <button id="btn-suivant" type="submit" name="BCSuivant" value="Commencer" title="Commencer" class="btn btn-form-cnaf btn-majeur-cnaf btn-mobile"
                  (click)="clickSuivant()" style="pointer-events: all; cursor: pointer;">
                  Commencer
              </button>
          </span>
      </div>
  </div>
</div>
